import DeleteSectionModal from "./DeleteSectionModal";
export default DeleteSectionModal;
